import ky from 'ky';

/**
 * Helper class that makes the ajax calls easier by automatically adding the -loading class to the given container
 * and preparing encoding the data correctly for a post call via ky
 */
export default class AjaxCaller {
    constructor( container_selector, debug = false ) {
        this.debug = debug;

        if (this.debug) console.log('AjaxCaller->constructor()', container_selector, container_selector.length, debug);

        this.setContainerSelector(container_selector);
        this.loading = false;
        this.$container = null;
    }

    setContainerSelector(container_selector) {
        this.container_selector = container_selector;
    }

    // SPINNER CONTROL
    // ----------------------------------------
    izLoading() {
        return this.loading;
    }

    getContainer() {
        if (this.debug) console.log('AjaxCaller->getContainer()', this.$container, this.container_selector);
        // if (this.$container === null) {
            this.$container = document.querySelector( this.container_selector );
            if (typeof this.$container === 'undefined') {
                this.$container = null;
            }
        // }
        return this.$container;
    }

    /**
     * Adds the '-loading' class to the container_selector given on initialisation
     */
    startLoading() {
        if (this.debug) console.log('AjaxCaller->startLoading()', this.getContainer());
        if (!this.loading) {
            this.loading = true;
            if (this.getContainer()) {
                this.getContainer().classList.add('-loading')
            }
        }
    }

    /**
     * Removes the '-loading' class to the container_selector given on initialisation
     */
    stopLoading() {
        if (this.debug) console.log('AjaxCaller->stopLoading()', this.getContainer());
        this.loading = false;
        if (this.getContainer()) {
            this.getContainer().classList.remove('-loading')
        }
    }

    /**
     * Makes an asynchronous post call via ky, using the wp ajax url and the correct form header + params encoding
     * @param payload
     * @returns {any}
     */
    async post( payload, show_spinner = true ) {

        if (show_spinner) {
            this.startLoading();
        }

        const result = await ky.post( lewobat_ajax.url, {
            headers: {
                'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: new URLSearchParams( payload )
        } ).json();

        if (show_spinner) {
            this.stopLoading();
        }

        return result;
    }

    /**
     Perform the LZW compression
     uncompressed - String. The string on which to perform the compression.
     https://rosettacode.org/wiki/LZW_compression#ES6_Version
     */
    compress(uncompressed)
    {
        // Initialize dictionary
        let dictionary = {};
        for (let i = 0; i < 256; i++)
        {
            dictionary[String.fromCharCode(i)] = i;
        }

        let word = '';
        let result = [];
        let dictSize = 256;

        for (let i = 0, len = uncompressed.length; i < len; i++)
        {
            let curChar = uncompressed[i];
            let joinedWord = word + curChar;

            // Do not use dictionary[joinedWord] because javascript objects
            // will return values for myObject['toString']
            if (dictionary.hasOwnProperty(joinedWord))
            {
                word = joinedWord;
            }
            else
            {
                result.push(dictionary[word]);
                // Add wc to the dictionary.
                dictionary[joinedWord] = dictSize++;
                word = curChar;
            }
        }

        if (word !== '')
        {
            result.push(dictionary[word]);
        }

        return result;
    }

    /**
     Decompress LZW array generated by LZW.compress()
     compressed - Array. The array that holds LZW compressed data.
     */
    decompress(compressed)
    {
        // Initialize Dictionary (inverse of compress)
        let dictionary = {};
        for (let i = 0; i < 256; i++)
        {
            dictionary[i] = String.fromCharCode(i);
        }

        let word = String.fromCharCode(compressed[0]);
        let result = word;
        let entry = '';
        let dictSize = 256;

        for (let i = 1, len = compressed.length; i < len; i++)
        {
            let curNumber = compressed[i];

            if (dictionary[curNumber] !== undefined)
            {
                entry = dictionary[curNumber];
            }
            else
            {
                if (curNumber === dictSize)
                {
                    entry = word + word[0];
                }
                else
                {
                    throw 'Error in processing';
                    return null;
                }
            }

            result += entry;

            // Add word + entry[0] to dictionary
            dictionary[dictSize++] = word + entry[0];

            word = entry;
        }

        return result;
    }

}